import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

// The sign-in modal lives inside Navigation, but other screens need to open it —
// the cart has to ask a guest to sign in before checkout. Holding the open state
// here (same pattern as CartDrawerContext) makes it reachable from anywhere
// without prop-drilling through the whole storefront.
const AuthModalContext = createContext({
  open: false,
  openAuthModal: () => {},
  closeAuthModal: () => {},
});

export const AuthModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  // Stable identities: AuthModal lists closeAuthModal in a useEffect dependency
  // array, so a fresh function each render would re-run that effect constantly.
  const openAuthModal = useCallback(() => setOpen(true), []);
  const closeAuthModal = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, openAuthModal, closeAuthModal }),
    [open, openAuthModal, closeAuthModal]
  );

  return (
    <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);

export default AuthModalContext;
